var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form-item',{staticClass:"pwdInput"},[_c('a-input-password',{directives:[{name:"decorator",rawName:"v-decorator",value:([
      'password',
      {
        rules: [
          {
            validator: _vm.checkFn,
          } ],
      } ]),expression:"[\n      'password',\n      {\n        rules: [\n          {\n            validator: checkFn,\n          },\n        ],\n      },\n    ]"}],staticClass:"inputPassword",attrs:{"placeholder":_vm.placeholder || _vm.$t('user.login.pwd.placeholder')}},[_c('icon-font',{attrs:{"slot":"prefix","type":"locker"},slot:"prefix"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }